import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import {
  POSTHOG_TRACKING_SOURCES,
  PosthogTrackingSource,
} from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';

interface UseBrandAndProductDrawerOptions {
  entityTag?: string;
  source?: PosthogTrackingSource;
}

export const useBrandAndProductDrawer = ({
  entityTag,
  source,
}: UseBrandAndProductDrawerOptions = {}) => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackKgBrandDrawerOpen } = usePosthogEvents();
  const product = params[queryKeys.product];
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.brandAndProductDrawer;

  const openDrawer = (product: string) => {
    trackKgBrandDrawerOpen(
      source ?? POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      entityTag ? [entityTag] : []
    );
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.brandAndProductDrawer,
      [queryKeys.product]: product,
    });
  };

  const closeDrawer = () =>
    deleteQueryParam([queryKeys.activeDrawer, queryKeys.product]);

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    product,
  };
};
